<template>
    <v-dialog v-model="dialog" max-width="500" scrollable>
        <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
                <v-icon>{{icons.dollar}}</v-icon>
                Invoice
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Send Invoices
            </v-card-title>
            <v-card-text>
                <v-radio-group>
                    <v-checkbox v-for="g in mylists" :label="`${g.name+' ('+g.data.length+' members)'}`" :value="g.id" v-model="selectedlists" />
                </v-radio-group>
                <v-text-field v-model="code" label="Invoice Code" />
                <v-text-field v-model="description" label="Description for line item" />
                <v-checkbox v-model="includeprice" label="Include Price" />
                <v-text-field type="number" v-if="includeprice" v-model="price" label="Price" />
                <p v-if="description && (description.length > 2)">[name] - {{description }}</p>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="Close()">
                    Cancel
                </v-btn>
                <v-spacer/>
                <v-btn text @click="sendInvoices()" :disabled="code&&description&&(description.length<2)">
                    Send {{totalToSend}} invoice{{totalToSend===1?'':'s'}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "InvoiceToGroup",
    components: {},
    data() {
      return {
        dialog: false,
        mylists: [],
        selectedlists: [],
        code:undefined,
        description: undefined,
        includeprice: false,
        price: undefined
      }
    },
    computed: {
      ...mapState(['icons']),
      totalToSend(){
        let l = this.mylists.filter(f=>{return this.selectedlists.includes(f.id)})
        let sum = 0;
        for(let i=0; i<l.length; i++){
          console.log(l[i].data.length)
          sum += l[i].data.length
        }
        return sum;
      }
    },
    watch:{
      dialog(n){
        if(n){
          this.getAllLists()
        }
      }
    },
    methods: {
      ...mapActions(['get', 'post']),
      Close() {
        this.dialog = false
      },
      async getAllLists() {
        let p = await this.post({path: 'api/profilesv2/getlists', body: {}})
        this.mylists = p
        console.log(p)
      },
      async sendInvoices(){
        if(!this.code || !this.description)return
        if(this.includeprice &&  this.price < 1)return
        let data = {
          group:this.selectedlists,
          code:this.code,
          description:this.description,
          includeprice: this.includeprice,
          price: this.price
        }
        let res = await this.post({path:'api/invoicesend/sendtogroupa4l',body:data})
        this.code = '';
        this.description = '';
        this.selectedlists = []
        this.includeprice = false
        this.price = 0
        this.Close()
        console.log(res)
      }
    }
  }
</script>

<style scoped>

</style>